/* eslint @typescript-eslint/no-redundant-type-constituents: 0 */
import { IntlMessageFormat } from 'intl-messageformat';

const _meta_title_fr = new IntlMessageFormat(
    [
        {
            type: 0,
            value: "Tous les professionnels %dp% classés par catégorie et par région. Trouvez l'entreprise que vous cherchez ou inscrivez la votre sur GAO...",
        },
    ],
    'fr',
);

const _meta_title_en = new IntlMessageFormat(
    [{ type: 0, value: 'Directory companies %dp%' }],
    'en',
);

export function meta_title(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _meta_title_fr.format(args) as unknown as string;
    }

    if (lang.startsWith('en')) {
        return _meta_title_en.format(args) as unknown as string;
    }

    return _meta_title_fr.format(args) as unknown as string;
}

const _meta_desc_fr = new IntlMessageFormat(
    [
        {
            type: 0,
            value: 'Annuaire des entreprises %dp%: pages jaunes des professionnels, sociétés et entreprises, administrations...',
        },
    ],
    'fr',
);

const _meta_desc_en = new IntlMessageFormat(
    [
        {
            type: 0,
            value: 'African business directory and search engine services, creating professional websites, news from Africa ...',
        },
    ],
    'en',
);

export function meta_desc(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _meta_desc_fr.format(args) as unknown as string;
    }

    if (lang.startsWith('en')) {
        return _meta_desc_en.format(args) as unknown as string;
    }

    return _meta_desc_fr.format(args) as unknown as string;
}

const _h1_fr = new IntlMessageFormat(
    [{ type: 0, value: 'Annuaire des sociétés %dp%' }],
    'fr',
);

const _h1_en = new IntlMessageFormat(
    [{ type: 0, value: 'Directory companies %dp%' }],
    'en',
);

export function h1(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _h1_fr.format(args) as unknown as string;
    }

    if (lang.startsWith('en')) {
        return _h1_en.format(args) as unknown as string;
    }

    return _h1_fr.format(args) as unknown as string;
}

const _h2_fr = new IntlMessageFormat(
    [{ type: 0, value: 'Les professionnels se présentent !' }],
    'fr',
);

const _h2_en = new IntlMessageFormat([{ type: 0, value: 'All pro categories!' }], 'en');

export function h2(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _h2_fr.format(args) as unknown as string;
    }

    if (lang.startsWith('en')) {
        return _h2_en.format(args) as unknown as string;
    }

    return _h2_fr.format(args) as unknown as string;
}

const _h2_help_fr = new IntlMessageFormat(
    [
        {
            type: 0,
            value: "Ils vous proposent une fiche descriptive riche d'informations : coordonnées, horaires d'ouverture, médias, description des servics, bons plans...",
        },
    ],
    'fr',
);

const _h2_help_en = new IntlMessageFormat(
    [{ type: 0, value: 'All registered professionals offer their custom pages.' }],
    'en',
);

export function h2_help(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _h2_help_fr.format(args) as unknown as string;
    }

    if (lang.startsWith('en')) {
        return _h2_help_en.format(args) as unknown as string;
    }

    return _h2_help_fr.format(args) as unknown as string;
}

const _btn_sign_up__text_fr = new IntlMessageFormat(
    [{ type: 0, value: 'Inscrivez votre société' }],
    'fr',
);

const _btn_sign_up__text_en = new IntlMessageFormat(
    [{ type: 0, value: 'Register your company' }],
    'en',
);

export function btn_sign_up__text(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _btn_sign_up__text_fr.format(args) as unknown as string;
    }

    if (lang.startsWith('en')) {
        return _btn_sign_up__text_en.format(args) as unknown as string;
    }

    return _btn_sign_up__text_fr.format(args) as unknown as string;
}

const _btn_sign_up__small_fr = new IntlMessageFormat(
    [{ type: 0, value: 'sur Go Africa Online' }],
    'fr',
);

const _btn_sign_up__small_en = new IntlMessageFormat(
    [{ type: 0, value: 'on Go Africa Online' }],
    'en',
);

export function btn_sign_up__small(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _btn_sign_up__small_fr.format(args) as unknown as string;
    }

    if (lang.startsWith('en')) {
        return _btn_sign_up__small_en.format(args) as unknown as string;
    }

    return _btn_sign_up__small_fr.format(args) as unknown as string;
}
